import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import initialState, { fieldInitial, usageInitial } from './states';
import { EnhanceStatus, LoadStatus } from './types';
import {
  enhanceRequest,
  enhanceSuccess,
  enhanceFailure,
  acceptEnhancementSuccess,
  usageRequest,
  usageSuccess,
  usageFailure,
  settingsRequest,
  settingsSuccess,
  settingsFailure,
  updateSettingsRequest,
  updateSettingsSuccess,
  updateSettingsFailure,
  dismissEnhancement,
} from './actions';

const setFeature = (state, feature, partial) => ({
  ...state,
  enhancements: {
    ...state.enhancements,
    [feature]: { ...fieldInitial, ...state.enhancements[feature], ...partial },
  },
});

const mergeUsage = (currentUsage, payload) => {
  if (!payload) return currentUsage;
  const next = { ...currentUsage };
  Object.keys(usageInitial).forEach((key) => {
    if (key === 'topUserName') {
      if (payload.topUserName !== undefined) next.topUserName = payload.topUserName;
    } else if (key === 'enabled') {
      if (payload.enabled != null) next.enabled = !!payload.enabled;
    } else if (payload[key] != null) {
      next[key] = payload[key];
    }
  });
  return next;
};

export default handleActions(
  {
    [enhanceRequest](state, { payload: { feature, text } }) {
      return setFeature(state, feature, {
        status: EnhanceStatus.LOADING,
        originalText: text,
        enhancedText: '',
        logID: null,
        error: null,
      });
    },
    [enhanceSuccess](state, { payload }) {
      const { feature, logID, enhancedText } = payload;
      const next = setFeature(state, feature, {
        status: EnhanceStatus.REVIEW,
        logID,
        enhancedText,
        error: null,
      });
      return { ...next, usage: mergeUsage(next.usage, payload) };
    },
    [enhanceFailure](state, { payload }) {
      const feature = payload?.feature;
      if (!feature) return state;
      return setFeature(state, feature, {
        status: EnhanceStatus.ERROR,
        error: payload.error || 'ai_request_failed',
      });
    },
    [acceptEnhancementSuccess](state, { payload: { feature, accepted } }) {
      if (!feature || !state.enhancements[feature]) return state;
      return setFeature(state, feature, accepted ? fieldInitial : {});
    },
    [dismissEnhancement](state, { payload: { feature } }) {
      if (!state.enhancements[feature]) return state;
      return setFeature(state, feature, fieldInitial);
    },
    [usageRequest](state) {
      return { ...state, usageStatus: LoadStatus.LOADING };
    },
    [usageSuccess](state, { payload }) {
      return {
        ...state,
        usage: { ...usageInitial, ...(payload || {}) },
        usageStatus: LoadStatus.LOADED,
      };
    },
    [usageFailure](state) {
      return { ...state, usageStatus: LoadStatus.ERROR };
    },
    [settingsRequest](state) {
      return { ...state, settingsStatus: LoadStatus.LOADING };
    },
    [settingsSuccess](state, { payload }) {
      return {
        ...state,
        usage: { ...usageInitial, ...(payload || {}) },
        settingsStatus: LoadStatus.LOADED,
      };
    },
    [settingsFailure](state) {
      return { ...state, settingsStatus: LoadStatus.ERROR };
    },
    [updateSettingsRequest](state) {
      return { ...state, settingsSaving: true };
    },
    [updateSettingsSuccess](state, { payload }) {
      return {
        ...state,
        usage: mergeUsage(state.usage, payload),
        settingsSaving: false,
      };
    },
    [updateSettingsFailure](state) {
      return { ...state, settingsSaving: false };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
